import angular from "angular"
import angularMoment from "angular-moment";
import trainsService from "../trainsService/trainsService";
import carsService from "../carsService/carsService";
import trainRoute from "../trainRoute/trainRoute";
import core from "../../core/core.module";

let mod = angular
    .module('bookingModule.routeTrainsCars', [
        angularMoment,
        trainsService,
        trainRoute,
        carsService,
        core
    ])
    .component('routeTrainsCars', {
        template: require('./route-trains-cars.html'),
        controller: [
            'trainsService',
            'carsService',
            'moment',
            'notify',
            '$timeout',
            '$uibModal',
            controller
        ],
        bindings: {
            routes: '<',
            route: '<',
            routeInd: '<',
            activeRouteInd: '<',
            adults: '<',
            children: '<',
            isEditing: '<',
            editingRouteInd: '<',
            switchRoute: '&',
            passengersCountChanged: '&',
            returnData: '&',
            finish: '&',
            distanceLoading: '<'
        }
    });

function controller(trainsService, carsService, moment, notify, $timeout, $uibModal) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.calendarLimitDate = moment().add(44, 'days').format('YYYY-MM-DD');
        $ctrl.calendarOpen = true;
        $ctrl.carTypesOpen = true;
        $ctrl.passengersOpen = false;
        $ctrl.trainsSortBy = 'departure';
        $ctrl.passengersCount = null;
        $ctrl.passengersText = null;
        updatePassengersData();

        $ctrl.carTypes = [
            {
                typeSlug: 'obwiy',
                typeLabel: 'Общий',
                minCost: null,
                checked: true
            },
            {
                typeSlug: 'sitting',
                typeLabel: 'Сидячий',
                minCost: null,
                checked: true
            },
            {
                typeSlug: 'placcart',
                typeLabel: 'Плацкартный',
                minCost: null,
                checked: true
            },
            {
                typeSlug: 'kupe',
                typeLabel: 'Купе',
                minCost: null,
                checked: true
            },
            {
                typeSlug: 'myagkiy',
                typeLabel: 'Мягкий',
                minCost: null,
                checked: true
            },
            {
                typeSlug: 'lux',
                typeLabel: 'Люкс',
                minCost: null,
                checked: true
            }
        ];

        $ctrl.trains = null;
        $ctrl.train = null;
        $ctrl.carType = null;
        $ctrl.carGroup = null;
        $ctrl.car = null;
        $ctrl.seatsStart = null;
        $ctrl.seatsEnd = null;
        $ctrl.seatsCount = 0;
        $ctrl.topSeatsCount = 0;
        $ctrl.bottomSeatsCount = 0;

        if ($ctrl.activeRouteInd == $ctrl.routeInd) {
            opened();
        }
    };

    $ctrl.$onChanges = function (changes) {
        if (changes.activeRouteInd &&
            !changes.activeRouteInd.isFirstChange() &&
            $ctrl.activeRouteInd == $ctrl.routeInd) {
            opened();
        }

        if (changes.adults && !changes.adults.isFirstChange()) {
            updatePassengersData();
        }

        if (changes.children && !changes.children.isFirstChange()) {
            updatePassengersData();
        }

    };

    $ctrl.changeRoute = function (ind) {
        if ($ctrl.isEditing) {
            notify({
                message: 'Current route is editing',
                classes: 'alert-danger'
            });
            return;
        }
        if (ind != $ctrl.routeInd) {
            $ctrl.switchRoute({routeInd: ind});
        }
    };

    function opened() {
        if ($ctrl.lastGetTrainsRequest === undefined) {
            getTrainsList();
        }
    }

    $ctrl.changeDepDate = function (dates) {
        $timeout(function () {
            $ctrl.route.depDate = dates[0];
            getTrainsList();
        });
    };

    $ctrl.retryGetTrains = function () {
        getTrainsList();
    };

    function getTrainsList() {

        clearTrainsList();

        $ctrl.trainsLoadingStatus = 'loading';
        $ctrl.getTrainsErrorMessage = null;

        if ($ctrl.lastGetTrainsRequest !== undefined) {
            trainsService.cancelRequest($ctrl.lastGetTrainsRequest);
        }

        $ctrl.lastGetTrainsRequest = trainsService.createRequest(
            $ctrl.route.depStation.code,
            $ctrl.route.arrStation.code,
            $ctrl.route.depDate
        );

        trainsService
            .doRequest($ctrl.lastGetTrainsRequest)
            .then(
                function (trains) {
                    $ctrl.trains = trains;
                    updateCarTypesFromTrainsList(trains);
                    $ctrl.trainsLoadingStatus = 'success';
                    $ctrl.sortTrains($ctrl.trainsSortBy);
                    $ctrl.carTypeFilterChanged();
                },
                function (error) {
                    $ctrl.trainsLoadingStatus = 'error';
                    $ctrl.getTrainsErrorMessage = error.data.messages[0];
                }
            );
    }

    function updateCarTypesFromTrainsList(trains) {
        for (let i = 0; i < $ctrl.carTypes.length; i++) {
            $ctrl.carTypes[i].minCost = null;
        }
        trains.forEach(function (train) {
            train.cars.forEach(function (car) {
                for (let i = 0; i < $ctrl.carTypes.length; i++) {
                    if ($ctrl.carTypes[i].typeSlug == car.typeSlug) {
                        $ctrl.carTypes[i].minCost = car.minCost;
                        break;
                    }
                }
            });
        });
    }

    $ctrl.sortTrains = function (trainsSortBy) {

        $ctrl.trainsSortBy = trainsSortBy;

        if (!$ctrl.trains) {
            return;
        }

        if ($ctrl.trainsSortBy == 'departure') {
            $ctrl.trains.sort(function (a, b) {
                if (a.depDate.isBefore(b.depDate)) {
                    return -1;
                }
                if (a.depDate.isSame(b.depDate)) {
                    return 0;
                }
                if (a.depDate.isAfter(b.depDate)) {
                    return 1;
                }
            });
        }

        if ($ctrl.trainsSortBy == 'arrival') {
            $ctrl.trains.sort(function (a, b) {
                if (a.arrDate.isBefore(b.arrDate)) {
                    return -1;
                }
                if (a.arrDate.isSame(b.arrDate)) {
                    return 0;
                }
                if (a.arrDate.isAfter(b.arrDate)) {
                    return 1;
                }
            });
        }

        if ($ctrl.trainsSortBy == 'time-in-way') {
            $ctrl.trains.sort(function (a, b) {
                let aMinutes = a.timeInWay.hours * 60 + a.timeInWay.minutes;
                let bMinutes = b.timeInWay.hours * 60 + b.timeInWay.minutes;
                return aMinutes - bMinutes;
            });
        }

        if ($ctrl.trainsSortBy == 'cost') {
            $ctrl.trains.sort(function (a, b) {
                return a.minCost - b.minCost;
            });
        }

    };

    $ctrl.carTypeFilterChanged = function () {

        for (let i = 0; i < $ctrl.trains.length; i++) {

            let train = $ctrl.trains[i];

            let displayTrain = false;

            for (let j = 0; j < train.cars.length; j++) {
                for (let k = 0; k < $ctrl.carTypes.length; k++) {
                    if (train.cars[j].typeSlug == $ctrl.carTypes[k].typeSlug) {
                        if ($ctrl.carTypes[k].checked) {
                            displayTrain = true;
                            train.cars[j].display = true;
                        } else {
                            train.cars[j].display = false;
                        }
                        break;
                    }
                }
            }

            $ctrl.trains[i].display = displayTrain;
        }

        if ($ctrl.train) {
            if ($ctrl.train.display) {

                if ($ctrl.carType) {
                    for (let i = 0; i < $ctrl.train.cars.length; i++) {
                        if ($ctrl.train.cars[i].typeSlug == $ctrl.carType) {
                            if (!$ctrl.train.cars[i].display) {
                                for (let j = 0; j < $ctrl.train.cars.length; j++) {
                                    if ($ctrl.train.cars[j].display) {
                                        $ctrl.selectCarType($ctrl.train.cars[j].typeSlug);
                                        break;
                                    }
                                }
                            }
                            break;
                        }
                    }
                }

            } else {
                clearTrain();
            }
        }

    };

    $ctrl.selectTrain = function (train) {

        if ($ctrl.train == train) {
            clearTrain();
            return;
        }

        $ctrl.train = train;

        $ctrl.carType = null;

        for (let i = 0; i < train.cars.length; i++) {
            if (train.cars[i].display) {
                $ctrl.carType = train.cars[i].typeSlug;
                break;
            }
        }

        clearCar();

        if ($ctrl.train && !$ctrl.train.carGroups) {
            getCarsList($ctrl.train);
        }
    };

    $ctrl.selectCarType = function (carTypeSlug) {
        if ($ctrl.carType != carTypeSlug) {
            $ctrl.carType = carTypeSlug;
            clearCar();
        }
    };

    $ctrl.retryGetCarsList = function () {
        getCarsList($ctrl.train);
    };

    function getCarsList(train) {
        train.carsLoadingStatus = 'loading';
        train.getCarsErrorMessage = null;
        carsService
            .getCars(
                $ctrl.route.depStation.code,
                $ctrl.route.arrStation.code,
                train.depDate.format('YYYY-MM-DD\THH:mm:ss'),
                train.number
            )
            .then(
                function (carGroups) {
                    train.carsLoadingStatus = 'success';
                    train.carGroups = carGroups;
                },
                function (error) {
                    train.carsLoadingStatus = 'error';
                    train.getCarsErrorMessage = error.data.messages[0];
                }
            );
    }

    $ctrl.selectCar = function (carGroup, car) {
        $ctrl.carGroup = carGroup;
        $ctrl.car = car;
        resetCarSeats($ctrl.car);
        clearSeats();
        if ($ctrl.car.schema) {
            setSchemaTooltips();
        }
        $ctrl.returnResult();

        // При отсутствии схемы, но наличии свободных мест вызывает функцию которая автоматически выберет все свободные места.
        if (!$ctrl.car.schemaExists && $ctrl.car.hasSeatNumbers) {
            $ctrl.selectAllSeats();
        }
    };

    $ctrl.selectSeat = function (seat) {
        if (!seat || !seat.isFree) {
            return;
        }

        resetCarSeats($ctrl.car);

        switch (true) {

            case (!$ctrl.seatsStart && !$ctrl.seatsEnd):
                $ctrl.seatsStart = seat.number;
                $ctrl.seatsEnd = seat.number;
                break;

            case ($ctrl.seatsStart === $ctrl.seatsEnd):
                if (seat.number < $ctrl.seatsStart) {
                    $ctrl.seatsStart = seat.number;
                } else if (seat.number === $ctrl.seatsStart) {
                    $ctrl.seatsStart = null;
                    $ctrl.seatsEnd = null;
                } else if (seat.number > $ctrl.seatsStart) {
                    $ctrl.seatsEnd = seat.number;
                }
                break;

            case ($ctrl.seatsStart === seat.number):
                $ctrl.seatsStart = $ctrl.seatsEnd;
                break;

            case ($ctrl.seatsEnd === seat.number):
                $ctrl.seatsEnd = $ctrl.seatsStart;
                break;

            default:
                if (seat.number < $ctrl.seatsStart) {
                    $ctrl.seatsStart = seat.number;
                } else if (seat.number > $ctrl.seatsEnd) {
                    $ctrl.seatsEnd = seat.number;
                } else {
                    let mod1 = Math.abs($ctrl.seatsStart - seat.number);
                    let mod2 = Math.abs($ctrl.seatsEnd - seat.number);
                    if (mod1 <= mod2) {
                        $ctrl.seatsStart = seat.number;
                    } else  {
                        $ctrl.seatsEnd = seat.number;
                    }
                }
                break;
        }

        if ($ctrl.seatsStart && $ctrl.seatsEnd) {
            for (let i = 0; i < $ctrl.car.seats.length; i++) {
                if ($ctrl.seatsStart === $ctrl.car.seats[i].number ||
                    $ctrl.seatsEnd === $ctrl.car.seats[i].number) {
                    $ctrl.car.seats[i].status = 'selected';
                }
                if ($ctrl.seatsStart < $ctrl.car.seats[i].number &&
                    $ctrl.car.seats[i].number < $ctrl.seatsEnd &&
                    $ctrl.car.seats[i].isFree) {
                    $ctrl.car.seats[i].status = 'inner';
                }
            }
        }

        $ctrl.seatsCount = 0;
        $ctrl.topSeatsCount = 0;
        $ctrl.bottomSeatsCount = 0;

        $ctrl.car.seats.forEach((seat) => {
            if (seat.isFree && (seat.status === 'selected' || seat.status === 'inner')) {
                $ctrl.seatsCount++;
                if (seat.position === 'bottom') $ctrl.bottomSeatsCount++;
                if (seat.position === 'top' || seat.position === 'middle') $ctrl.topSeatsCount++;
            }
        });

        $ctrl.car.seats = setTooltipTitlesForSeats($ctrl.car.seats);
        $ctrl.returnResult();
    };

    // Функция для автоматического выбора всех мест, т.е. в диапазоне [минимальное место]-[максимальное место].
    $ctrl.selectAllSeats = function () {
        let minFreeSeat = $ctrl.car.seats[0];
        let maxFreeSeat = $ctrl.car.seats[$ctrl.car.seats.length - 1];

        $ctrl.seatsStart = minFreeSeat.number;
        $ctrl.seatsEnd = maxFreeSeat.number;
        $ctrl.seatsCount = $ctrl.car.freeSeatsCount;
        $ctrl.topSeatsCount = 0;
        $ctrl.bottomSeatsCount = 0;
        $ctrl.returnResult();
    }

    function setSchemaTooltips() {
        $ctrl.car.schema.schemaInfo = setTooltipTitlesForAdditionalElements($ctrl.car.schema.schemaInfo);
        $ctrl.car.seats = setTooltipTitlesForSeats($ctrl.car.seats);
    }

    function setTooltipTitlesForSeats(seats) {
        return seats.map((seat) => ({
            ...seat,
            tooltipTitle: getTooltipTitleForSeat(seat)
        }));
    }

    function setTooltipTitlesForAdditionalElements(schemaInfo) {
        if (schemaInfo.additionalElements) {
            for (let i = 0; i < schemaInfo.additionalElements.length; i++) {
                schemaInfo.additionalElements[i].tooltipTitle =
                    getTooltipTitleForAdditionalElement(schemaInfo.additionalElements[i].type);
            }
        }
        if (schemaInfo.parameter && schemaInfo.parameter.additionalElements) {
            for (let i = 0; i < schemaInfo.parameter.additionalElements.length; i++) {
                schemaInfo.parameter.additionalElements[i].tooltipTitle =
                    getTooltipTitleForAdditionalElement(schemaInfo.parameter.additionalElements[i].type);
            }
        }
        if (schemaInfo.parameter.sections) {
            schemaInfo.parameter.sections.forEach(({ additionalElements }) => {
                for (let i = 0; i < additionalElements.length; i++) {
                    additionalElements[i].tooltipTitle =
                        getTooltipTitleForAdditionalElement(additionalElements[i].type);
                }
            });
        }
        return schemaInfo;
    }

    function getTooltipTitleForSeat(seat) {
        switch (true) {
            case (!seat.isFree):
                return 'Занято';
            case (seat.status === 'selected'):
                return 'Выбрано';
            case (seat.status === 'inner'):
                return 'В диапазоне';
            case ($ctrl.carType === 'sitting'):
                return `Сидячее, ${$ctrl.carGroup.tariff} ₸`;
            case (seat.type === 'sit'):
                return `Сидячее, ${$ctrl.carGroup.tariff} ₸`;
            case (seat.position === 'middle'):
                return `Посередине, ${$ctrl.carGroup.tariff} ₸`;
            default:
                return `${(seat.position === 'bottom') ? 'Нижнее' : 'Верхнее'}, ${$ctrl.carGroup.tariff} ₸`;
        }
    }

    function getTooltipTitleForAdditionalElement(type) {
        switch (type) {
            case 'toilet':
                return 'Туалет';
            case 'conductor':
                return 'Проводник';
            case 'buffet':
                return 'Буфет';
            case 'shower':
                return 'Душ';
            case 'disablePersonMark':
                return 'Для людей с инвалидностью';
            case 'table':
                return 'Стол';
            case 'dispensary':
                return 'Диспенсер';

            default:
                return '';
        }
    }

    function resetCarSeats(car) {
        if (car.hasSeatNumbers) {
            for (let i = 0; i < car.seats.length; i++) {
                car.seats[i].status = null;
            }
        }
    }

    function clearTrainsList() {
        $ctrl.trains = null;
        for (let i = 0; i < $ctrl.carTypes.length; i++) {
            $ctrl.carTypes[i].minCost = null;
        }
        clearTrain();
    }

    function clearTrain() {
        $ctrl.train = null;
        $ctrl.carType = null;
        clearCar();
    }

    function clearCar() {
        $ctrl.carGroup = null;
        $ctrl.car = null;
        clearSeats();
    }

    function clearSeats() {
        $ctrl.seatsStart = null;
        $ctrl.seatsEnd = null;
        $ctrl.seatsCount = 0;
        $ctrl.topSeatsCount = 0;
        $ctrl.bottomSeatsCount = 0;
        $ctrl.returnResult();
    }

    $ctrl.returnResult = function () {
        $ctrl.returnData({
            data: {
                train: $ctrl.train,
                carGroup: $ctrl.carGroup,
                car: $ctrl.car,
                seatsStart: $ctrl.car ? ($ctrl.car.hasSeatNumbers ? $ctrl.seatsStart : null) : null,
                seatsEnd: $ctrl.car ? ($ctrl.car.hasSeatNumbers ? $ctrl.seatsEnd : null) : null,
                seatsCount: $ctrl.seatsCount,
                topSeatsCount: $ctrl.topSeatsCount,
                bottomSeatsCount: $ctrl.bottomSeatsCount,
            }
        });
    };

    $ctrl.openPassengerControl = function (open) {
        $ctrl.passengersOpen = open;
    };

    function updatePassengersData() {
        $ctrl.passengersCount = +$ctrl.adults + +$ctrl.children;
        if (+$ctrl.adults && !(+$ctrl.children)) {
            if ($ctrl.adults == 1) {
                $ctrl.passengersText = '1 взрослый';
            } else {
                $ctrl.passengersText = $ctrl.adults + ' взрослых';
            }
        }
        if (+$ctrl.adults && +$ctrl.children) {
            $ctrl.passengersText = $ctrl.adults + ' взр. ' + $ctrl.children + ' дет.';
        }
    }

    $ctrl.changePassCount = function (type, oper) {
        if (type == 'adult') {
            if (oper == 'minus') {
                $ctrl.adults--;
            } else {
                $ctrl.adults++;
            }
        } else {
            if (oper == 'minus') {
                $ctrl.children--;
            } else {
                $ctrl.children++;
            }
        }
        $ctrl.passengersCountChanged({
            adults: $ctrl.adults,
            children: $ctrl.children
        });
    };

    $ctrl.openTrainFullRoute = function (train) {
        $uibModal.open({
            component: 'trainRoute',
            size: 'lg',
            resolve: {
                route: function () {
                    return $ctrl.route;
                },
                train: function () {
                    return train
                }
            },
            windowTemplateUrl: 'train-route-popup.html'
        }).result.then(
            function () {
                $ctrl.returnResult();
            },
            function () {
                $ctrl.returnResult();
            }
        )
    };

}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/booking-module/route-trains-cars/route-trains-cars.js